import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2901e200"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tir-pm-icon-picker" }
const _hoisted_2 = { class: "tir-pm-icon-picker__select-info" }
const _hoisted_3 = { class: "tir-pm-icon-picker__label" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M17.5 13.75L12 8.25L6.5 13.75",
    stroke: "#3D424B",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tir-pm-icon-picker__popover-content-divider" }, null, -1))
const _hoisted_8 = ["onClick"]

import { computed, ref, watch } from "vue";
import { TirPmPopover, PopoverPositionEnum } from "tir-pm-popover";
import { TirPmScrollbar } from "tir-pm-scrollbar";
import { IconColorType, IconType } from "./types";
import { SelectedIconModel } from "./models";
import TirPmIconPickerViewIcon from "./TirPmIconPickerViewIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TirPmIconPicker',
  props: {
    modelValue: {},
    icons: {},
    colors: {},
    columnsCount: { default: 4 },
    rowsCount: { default: 5 },
    label: { default: "Иконка" }
  },
  emits: ["update:modelValue", "selectIcon", "selectColor"],
  setup(__props: any, { emit }) {

const props = __props;





/**ID выбранной иконки */
const selectedIconId = ref<string | undefined>(props.modelValue?.IconId);
/**ID выбранного цвета */
const selectedIconColorId = ref<string | undefined>(props.modelValue?.ColorId);
/**Выбранная иконка */
const selectedIcon = computed(() =>
  props.icons.find((icon) => icon.IconId === selectedIconId.value)
);
/**Выбранный цвет */
const selectedIconColor = computed(() =>
  props.colors.find((color) => color.ColorId === selectedIconColorId.value)
);

/**Иконка и цвет выбраны */
const isSelected = computed(
  () => selectedIcon.value && selectedIconColor.value
);

watch(
  () => props.modelValue,
  () => {
    if (selectedIconId.value !== props.modelValue?.IconId)
      selectedIconId.value = props.modelValue?.IconId;
    if (selectedIconColorId.value !== props.modelValue?.ColorId)
      selectedIconColorId.value = props.modelValue?.ColorId;
  },
  { deep: true }
);

/**Открыт ли поповер */
const isOpened = ref(false);
/**При открытии поповера */
const onOpen = () => (isOpened.value = true);
/**При закрытии попомера */
const onClose = () => (isOpened.value = false);

/**Высота для скролла */
const height = computed(
  () => `${props.rowsCount * 2 + (props.rowsCount - 0.063) * 0.5}rem`
);

const gridTemplateColumsContent = computed(() => {
  const listWidth = props.columnsCount * 2 + (props.columnsCount - 0.063) * 0.5 + 0.625;
  return `${listWidth}rem 1.063rem ${listWidth}rem`;
});

const gridTemplateColumnsList = computed(() => {
  return `repeat(${props.columnsCount}, 2rem)`;
});

const updateModelValue = () => {
  if (selectedIconId.value && selectedIconColorId.value)
    emit(
      "update:modelValue",
      new SelectedIconModel({
        IconId: selectedIconId.value,
        ColorId: selectedIconColorId.value,
      })
    );
};

const selectIcon = (icon: IconType) => {
  selectedIconId.value = icon.IconId;
  emit("selectIcon", icon);
  updateModelValue();
};

const selectColor = (color: IconColorType) => {
  selectedIconColorId.value = color.ColorId;
  emit("selectColor", color);
  updateModelValue();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(TirPmPopover), {
      padding: "0.75rem 0 0.25rem 0",
      position: _unref(PopoverPositionEnum).Bottom,
      onOpen: onOpen,
      onClose: onClose
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", {
          class: "tir-pm-icon-picker__popover-content",
          style: _normalizeStyle({ gridTemplateColumns: gridTemplateColumsContent.value })
        }, [
          _createElementVNode("div", null, [
            _createVNode(_unref(TirPmScrollbar), {
              style: _normalizeStyle({ maxHeight: height.value }),
              "is-vertical-left": ""
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "tir-pm-icon-picker__grid-list",
                  style: _normalizeStyle({
                  gridTemplateColumns: gridTemplateColumnsList.value,
                  paddingLeft: '0.625rem',
                })
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.icons, (icon) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: icon.IconId,
                      class: _normalizeClass([
                    'tir-pm-icon-picker__list-item-wrap',
                    {
                      'is-selected':
                        selectedIconId.value && selectedIconId.value === icon.IconId,
                    },
                  ]),
                      onClick: ($event: any) => (selectIcon(icon))
                    }, [
                      _createVNode(TirPmIconPickerViewIcon, { icon: icon }, null, 8, ["icon"])
                    ], 10, _hoisted_6))
                  }), 128))
                ], 4)
              ]),
              _: 1
            }, 8, ["style"])
          ]),
          _hoisted_7,
          _createElementVNode("div", null, [
            _createVNode(_unref(TirPmScrollbar), {
              style: _normalizeStyle({ maxHeight: height.value })
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "tir-pm-icon-picker__grid-list",
                  style: _normalizeStyle({ gridTemplateColumns: gridTemplateColumnsList.value })
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colors, (color) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: color.ColorId,
                      class: _normalizeClass([
                    'tir-pm-icon-picker__list-item-wrap',
                    {
                      'is-selected':
                        selectedIconColorId.value &&
                        selectedIconColorId.value === color.ColorId,
                    },
                  ]),
                      onClick: ($event: any) => (selectColor(color))
                    }, [
                      _createElementVNode("div", {
                        class: "tir-pm-icon-picker__color-square",
                        style: _normalizeStyle({ backgroundColor: color.Color })
                      }, null, 4)
                    ], 10, _hoisted_8))
                  }), 128))
                ], 4)
              ]),
              _: 1
            }, 8, ["style"])
          ])
        ], 4)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(['tir-pm-icon-picker__select', { 'is-selected': isSelected.value }])
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.label), 1),
            (selectedIcon.value && selectedIconColor.value)
              ? (_openBlock(), _createBlock(TirPmIconPickerViewIcon, {
                  key: 0,
                  icon: selectedIcon.value,
                  color: selectedIconColor.value
                }, null, 8, ["icon", "color"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass([
            'tir-pm-icon-picker__select-chevron',
            { 'is-opened': isOpened.value },
          ])
          }, _hoisted_5, 2)
        ], 2)
      ]),
      _: 1
    }, 8, ["position"])
  ]))
}
}

})